export default __webpack_public_path__ + "static/media/icone-tutoriel.157bc770.svg";